<mat-spinner
    class="st-loader-spinner"
    [strokeWidth]="strokeWidth"
    [diameter]="diameter" />
<mat-progress-spinner
    class="st-loader-proggress-spinner"
    mode="determinate"
    [strokeWidth]="strokeWidth"
    [diameter]="diameter"
    [value]="100" />
<div class="st-loader-label">{{ productLabel }}</div>

<!-- <ng-content select="[loader-hide-body]"></ng-content> -->
<!-- <div *ngIf="active"
     class="loader-container"
     [style.background]="background">
  <span>{{label}}</span>
  <br />
  <div>
    <div class="spinner-loader-small-gray">
      <mat-spinner [strokeWidth]="50"
                   [diameter]="100"
                   class="loader-spinner"></mat-spinner>
    </div>
  </div>
</div>
<div *ngIf="active && login"
     class="loader-container-login">
  <div class="ap-logo">
  </div>

  <span *ngIf="login"
        class="app-title">{{productLabel}}</span>
  <span class="loader-label-login">{{label}}</span>
  <br />
  <div>
    <div class="spinner-loader-small-gray">
    </div>
  </div>
</div>
 -->
